// @ts-nocheck
import { getInvoice } from "@insite/client-framework/Services/InvoiceService";
import { TaxExemptionCertificateModel } from "@insite/client-framework/Types/ApiModels";
import {
    getSingleTaxExemptionCertificate,
    GetSingleTaxExemptionCertificateApiParameter,
} from "@store/Framework/Services/TaxExemptionCertificatesService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    { certificateId: string },
    GetSingleTaxExemptionCertificateApiParameter,
    TaxExemptionCertificateModel
>;

export const DispatchBeginLoadInvoice: HandlerType = props => {
    props.dispatch({
        type: "Data/TaxExemptionCertificates/BeginLoadTaxExemptionCertificatesByCertificateId",
        certificateId: props.parameter.certificateId,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        certificateId: props.parameter.certificateId,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getSingleTaxExemptionCertificate(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Data/TaxExemptionCertificates/FailedToLoadTaxExemptionCertificatesByCertificateId",
                certificateId: props.parameter.certificateId,
                status: 404,
            });
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadInvoice: HandlerType = props => {
    props.dispatch({
        type: "Data/TaxExemptionCertificates/CompleteLoadTaxExemptionCertificatesByCertificateId",
        model: props.apiResult,
    });
};

export const chain = [DispatchBeginLoadInvoice, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadInvoice];

const loadTaxExemptionCertificatesByCertificateId = createHandlerChainRunner(
    chain,
    "LoadTaxExemptionCertificatesByCertificateId",
);
export default loadTaxExemptionCertificatesByCertificateId;
